export default "__VITE_ASSET__3gQ6FnNX__"